import React from 'react';
import { Checkbox } from '@fluentui/react-components';
import { toDisplayString } from '../../../logic/displayString';

interface FacetValue {
  count: number;
}

interface FacetFieldCheckboxesProps {
  facetData: Record<string, FacetValue>;
  facetSelection: string[];
  onChangeFacet: (name: string, valueKey: string) => void;
  name: string;
}

const FacetFieldCheckboxes: React.FC<FacetFieldCheckboxesProps> = ({
  facetData,
  facetSelection,
  onChangeFacet,
  name,
}) => {
  if (!facetData || !facetSelection) {
    return null;
  }

  const sortedValueNames = Object.keys(facetData).sort();

  return (
    <ul>
      {sortedValueNames.map((valueKey, index) => {
        const value = facetData[valueKey];
        if (!value || value.count <= 0) {
          return null;
        }

        const isChecked = facetSelection.includes(valueKey);
        const displayValue = toDisplayString(valueKey);
        const countDisplay = `(${value.count})`;

        return (
          <li key={index}>
            <Checkbox
              label={`${displayValue} ${countDisplay}`}
              checked={isChecked}
              disabled={!value.count}
              onChange={() => onChangeFacet(name, valueKey)}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default FacetFieldCheckboxes;
